import { useQuery } from "@tanstack/react-query"

import { TokenInfo } from "./token"
import { W_AR } from "../settings"

export async function getUserTokens(): Promise<TokenInfo[]> {
  console.log("userTokens - fetching")
  const result = (await (window.arweaveWallet as any).userTokens()) as {
    Denomination: number
    Logo: string
    Ticker: string
    Name: string
    processId: string
    // balance: string
  }[]

  // PATCH FOR AR to be displayed as wAR
  const patchedTokenTicker = (token: { processId: string; Ticker: string }) =>
    token.processId == W_AR.id ? W_AR.ticker : token.Ticker

  const userTokens = result
    .map((token) => ({
      id: token.processId,
      denomination: token.Denomination,
      ticker: patchedTokenTicker(token),
      logo: token.Logo,
      name: token.Name,
      // balance: BigInt(parseNumberAsBigInt(token.balance, token.Denomination)),
    }))
    .filter(
      (token) =>
        !token.ticker.toLowerCase().includes("botega lp") &&
        !token.ticker.toLowerCase().includes("botega v2 lp") &&
        !token.ticker.toLowerCase().includes("bark v2 lp"),
    )

  console.log("userTokens", userTokens)
  return userTokens
}

export function useUserTokens(): TokenInfo[] | null | undefined {
  const { data, isLoading } = useQuery({
    queryKey: ["user-tokens"],
    queryFn: () => getUserTokens(),
  })

  return isLoading ? null : data
}
